import React from "react";
import { useTranslation } from "react-i18next";

import GhxpArrows from "./GhxpArrows";
import GhxpLogo from "./GhxpLogo";
import { Signature, Tagline } from "./GhxpUi";
import yearBackground from "../../../assets/img/ghExperience/year-2026.svg";

// Abertura automática: o convite chega fechado, como o envelope navy do Projeto Visual (pág. 20),
// e toca sozinho por ~4 s — vinco de luz, planos em profundidade, logo letra a letra com um brilho,
// tagline em dois tempos e um anel que se completa no instante em que o convite se abre em perspectiva.
// Toda a coreografia são delays de CSS; os keyframes só correm com "is-playing" (fonte carregada e aba
// visível), no mesmo instante em que o JS arma o relógio da abertura automática ('closed' → 'opening' → 'open').
// Qualquer clique, toque, rolagem ou tecla pula direto para a abertura.
function GhxpIntro({ state, playing, onOpen }) {
  const { t } = useTranslation();
  const tagline = /^(.*?)<strong>(.*?)<\/strong>(.*)$/.exec(t("ghxp_tagline"));

  return (
    <div
      className={`ghxpIntro is-${state} ${playing ? "is-playing" : ""}`}
      aria-hidden={state === "open"}
      onPointerDown={state === "closed" ? onOpen : undefined}
    >
      {/* As duas metades do envelope; o vinco de luz fica na borda interna de cada uma */}
      <div className="ghxpIntro__half ghxpIntro__half--a" />
      <div className="ghxpIntro__half ghxpIntro__half--b" />

      {/* Dois planos em profundidade: padrão 2026 ao fundo e a seta laranja se desenhando */}
      <div className="ghxpIntro__layer ghxpIntro__layer--deep">
        <img className="ghxpIntro__pattern" src={yearBackground} alt="" aria-hidden="true" />
      </div>
      <div className="ghxpIntro__layer ghxpIntro__layer--mid">
        <GhxpArrows variant="outline" className="ghxpIntro__arrows" />
      </div>

      <div className="ghxpIntro__stage">
        <div className="ghxpIntro__card">
          <div className="ghxpIntro__logoBox">
            <span className="ghxpIntro__rule ghxpIntro__rule--top" aria-hidden="true" />
            <span className="ghxpIntro__rule ghxpIntro__rule--bottom" aria-hidden="true" />
            <GhxpLogo className="ghxpIntro__logo" sheen />
          </div>

          {tagline ? (
            <p className="ghxpTagline ghxpIntro__tagline">
              <span className="ghxpIntro__word ghxpIntro__word--a">{tagline[1].trim()}</span>{" "}
              <span className="ghxpIntro__word ghxpIntro__word--b">
                <strong>{tagline[2]}</strong>
                {tagline[3]}
              </span>
            </p>
          ) : (
            <Tagline className="ghxpIntro__tagline" />
          )}

          <button type="button" className="ghxpIntro__seal" onClick={onOpen} aria-label={t("ghxp_intro_open")}>
            <span className="ghxpIntro__sealRing" aria-hidden="true">
              <svg className="ghxpIntro__sealProgress" viewBox="0 0 80 80" focusable="false">
                <circle cx="40" cy="40" r="38" />
              </svg>
              <GhxpArrows variant="solid" size="sm" />
            </span>
            <span className="ghxpIntro__sealLabel">{t("ghxp_intro_auto")}</span>
          </button>
          <p className="ghxpIntro__hint">{t("ghxp_intro_skip")}</p>
        </div>

        <Signature className="ghxpIntro__signature" />
      </div>
    </div>
  );
}

export default GhxpIntro;
